"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliceLayout = exports.SliceLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_value_1 = require("./entity-value");
var content_node_1 = require("./content-node");
var main_aside_1 = require("../elements/main-aside");
var grid_1 = require("../elements/grid");
var entity_link_value_1 = require("./entity-link-value");
var lodash_1 = require("lodash");
var sprintf_js_1 = require("sprintf-js");
var content_title_1 = require("../elements/content-title");
var block_layout_1 = require("./block-layout");
var entity_linked_items_grid_1 = require("./entity-linked-items-grid");
var use_lang_1 = require("../../hooks/use-lang");
var cell_label_1 = require("../elements/cell-label");
// -------- Types -------->
var formatLayoutName = function (name) {
  return name.replace(/(Page Layout|Slice Layout)/ig, '');
};
exports.SliceLayoutDefaultProps = {
  formatName: formatLayoutName
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    padding: ", " 2px ", ";\n  "], ["\n    border-top: 1px solid ", ";\n    padding: ", " 2px ", ";\n  "])), theme_1.theme.COLOR('line-semi-subtle'), theme_1.theme.UNIT(0), theme_1.theme.UNIT(1)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n  "])), theme_1.theme.UNIT(0), theme_1.theme.UNIT(3), theme_1.theme.UNIT(1))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    ", ";\n    .shp-cell-label {\n      color: ", ";\n    }\n\n  "], ["\n    color: ", ";\n    ", ";\n    .shp-cell-label {\n      color: ", ";\n    }\n\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.FILL('text'), theme_1.theme.COLOR('text'))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    font-size: 1em;\n    font-weight: 400;\n    span {\n      color: ", " !important;\n    }\n  "], ["\n    margin-bottom: ", ";\n    font-size: 1em;\n    font-weight: 400;\n    span {\n      color: ", " !important;\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.COLOR('dark'))
});
var OutroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(6))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n    display: flex;\n    position: relative;\n    z-index: 50;\n    ", ";\n    flex-direction: column;\n  "], ["\n    padding: ", " 0 ", ";\n    display: flex;\n    position: relative;\n    z-index: 50;\n    ", ";\n    flex-direction: column;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG_END('line', 1)),
  tablet: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    align-items: center;\n    justify-content: space-between;\n    flex-direction: row;\n  "], ["\n    align-items: center;\n    justify-content: space-between;\n    flex-direction: row;\n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var LinkedValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    z-index: 2; \n  "], ["\n    z-index: 2; \n  "])))
});
var LinkedLinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    z-index: 2; \n  "], ["\n    z-index: 2; \n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    font-weight: 500;\n    font-size: ", ";\n    margin-bottom: ", ";\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "], ["\n    font-weight: 500;\n    font-size: ", ";\n    margin-bottom: ", ";\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "])), theme_1.theme.FONT_SIZE(18), theme_1.theme.UNIT(3))
});
var SubtitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    font-weight: 400;\n    font-size: ", ";\n    margin-bottom: ", ";\n    margin-top: -", ";\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "], ["\n    font-weight: 400;\n    font-size: ", ";\n    margin-bottom: ", ";\n    margin-top: -", ";\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "])), theme_1.theme.FONT_SIZE(16), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1))
});
var BlockStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(1))
});
var LayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    ", ";\n    padding-top: ", ";\n    margin-top: ", ";\n    ", ";\n    height: 38px;\n  "], ["\n    ", ";\n    padding-top: ", ";\n    margin-top: ", ";\n    ", ";\n    height: 38px;\n  "])), ValueStyles, theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG()),
  tablet: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    background: none;\n    margin-top: 0;\n    padding-top: 0;\n    padding-left: ", ";\n    margin-right: ", ";\n  "], ["\n    background: none;\n    margin-top: 0;\n    padding-top: 0;\n    padding-left: ", ";\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(5), theme_1.theme.UNIT(3))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme_1.theme.UNIT(4))
});
var BlocksStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: -", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: -", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Grid: (0, styled_components_1.default)(entity_linked_items_grid_1.EntityLinkedItemsGrid)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Blocks: (0, styled_components_1.default)(grid_1.Grid)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), BlocksStyles),
  Header: styled_components_1.default.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Layout: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled_components_1.default.div(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  LinkedValue: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), LinkedValueStyles),
  LinkedLinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), LinkedLinkValueStyles),
  Title: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Intro: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Outro: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles),
  Content: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Label: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Block: (0, styled_components_1.default)(block_layout_1.BlockLayout)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), BlockStyles)
};
var SliceLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    formatName = props.formatName,
    number = props.number;
  var intro = entity.intro,
    content = entity.content,
    outro = entity.outro,
    label = entity.label,
    title = entity.title,
    _a = entity.icons,
    icons = _a === void 0 ? [] : _a,
    subtitle = entity.subtitle,
    _b = entity.images,
    images = _b === void 0 ? [] : _b,
    _c = entity.backgroundImages,
    backgroundImages = _c === void 0 ? [] : _c,
    color = entity.color,
    themeMode = entity.themeMode,
    backgroundColor = entity.backgroundColor,
    _d = entity.pages,
    pages = _d === void 0 ? [] : _d,
    _e = entity.videos,
    videos = _e === void 0 ? [] : _e,
    _f = entity.people,
    people = _f === void 0 ? [] : _f,
    _g = entity.feedEntries,
    feedEntries = _g === void 0 ? [] : _g,
    _h = entity.links,
    links = _h === void 0 ? [] : _h,
    _j = entity.blocks,
    blocks = _j === void 0 ? [] : _j,
    _k = entity.organisations,
    organisations = _k === void 0 ? [] : _k,
    disabled = entity.disabled,
    _l = entity.indicators,
    indicators = _l === void 0 ? [] : _l,
    _m = entity.indicatorGroups,
    indicatorGroups = _m === void 0 ? [] : _m,
    _o = entity.entityTypes,
    entityTypes = _o === void 0 ? [] : _o,
    bodyFontType = entity.bodyFontType,
    headerFontType = entity.headerFontType,
    _p = entity.connectedEntities,
    connectedEntities = _p === void 0 ? [] : _p,
    viewTarget = entity.viewTarget,
    subviewTarget = entity.subviewTarget,
    entityLayout = entity.entityLayout;
  var t = (0, use_lang_1.useLang)();
  var defaultLayout = {
    id: 'default',
    name: "(Default)",
    slug: 'default',
    __typename: 'SliceLayout'
  };
  var layout = entity.layout || defaultLayout;
  // todo - add stuff!
  var hasAside = false;
  // let's map over links to show the targets behind them if possible
  var gridItems = (0, lodash_1.filter)(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([themeMode && react_1.default.createElement(My.LinkedValue, {
    variant: 'card',
    showMenu: true,
    entity: themeMode
  })], __read(pages.map(function (page) {
    return react_1.default.createElement(My.LinkedLinkValue, {
      variant: 'card',
      showMenu: true,
      entity: page
    });
  })), false), __read(people.map(function (person) {
    return react_1.default.createElement(My.LinkedLinkValue, {
      variant: 'card',
      showMenu: true,
      entity: person
    });
  })), false), __read(organisations.map(function (organisation) {
    return react_1.default.createElement(My.LinkedLinkValue, {
      variant: 'card',
      showMenu: true,
      entity: organisation
    });
  })), false), __read(feedEntries.map(function (feedEntry) {
    return react_1.default.createElement(My.LinkedLinkValue, {
      variant: 'card',
      showMenu: true,
      entity: feedEntry
    });
  })), false), __read(links.map(function (link) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      showMenu: true,
      entity: link
    });
  })), false), __read(videos.map(function (video) {
    return react_1.default.createElement(My.LinkedLinkValue, {
      variant: 'card',
      showMenu: true,
      label: "Video",
      entity: video
    });
  })), false), __read(entityTypes.map(function (entityType) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      showMenu: true,
      label: "Entity Type",
      entity: entityType
    });
  })), false), __read(indicators.map(function (indicator) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      showMenu: true,
      entity: indicator
    });
  })), false), __read(indicatorGroups.map(function (indicatorGroup) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      showMenu: true,
      entity: indicatorGroup
    });
  })), false), __read(icons.map(function (icon) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      showMenu: true,
      entity: icon
    });
  })), false), __read(images.map(function (image) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      showMenu: true,
      label: "Image",
      entity: image
    });
  })), false), __read(backgroundImages.map(function (image) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      showMenu: true,
      label: "Background Image",
      entity: image
    });
  })), false), __read(connectedEntities.map(function (entityType) {
    return react_1.default.createElement(My.LinkedValue, {
      variant: 'card',
      label: "Connected Entity Field",
      showMenu: true,
      entity: entityType
    });
  })), false), [entityLayout && react_1.default.createElement(My.LinkedValue, {
    variant: 'card',
    showMenu: true,
    label: "Connections Layout",
    entity: entityLayout
  }), viewTarget && react_1.default.createElement(My.Value, {
    entity: viewTarget,
    label: "View Target"
  }), subviewTarget && react_1.default.createElement(My.Value, {
    entity: subviewTarget,
    label: "Sub-View Target"
  }), headerFontType && react_1.default.createElement(My.LinkedValue, {
    label: "Header Font Type",
    variant: 'card',
    showMenu: true,
    entity: headerFontType
  }), bodyFontType && react_1.default.createElement(My.LinkedValue, {
    label: "Body Font Type",
    variant: 'card',
    showMenu: true,
    entity: bodyFontType
  }), color && react_1.default.createElement(My.LinkedValue, {
    variant: 'card',
    showMenu: true,
    entity: color
  }), backgroundColor && react_1.default.createElement(My.LinkedValue, {
    variant: 'card',
    showMenu: true,
    label: "Background {{COLOR}}",
    entity: backgroundColor
  })], false));
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.MainAside, {
    main: react_1.default.createElement(My.Main, null, react_1.default.createElement(My.Header, null, react_1.default.createElement(My.Value, {
      showMenu: true,
      imageSpacing: 2,
      imageSize: 26,
      badge: disabled && t('Slice Disabled'),
      entity: entity,
      name: "",
      label: number !== undefined ? (0, sprintf_js_1.sprintf)("{{SLICE}} %s – %s", number, entity.name) : "{{SLICE}}"
    }), react_1.default.createElement(My.Layout, {
      variant: "card",
      showMenu: false,
      imageSize: 34,
      entity: layout
    })), react_1.default.createElement(My.Body, null, label && react_1.default.createElement(My.Label, null, label), title && react_1.default.createElement(My.Title, null, title), subtitle && react_1.default.createElement(My.Subtitle, null, subtitle), intro && react_1.default.createElement(My.Intro, {
      entity: intro
    }), content && react_1.default.createElement(My.Content, {
      entity: content
    }), !!gridItems.length && react_1.default.createElement(My.Grid, {
      spacing: 4,
      columns: 3,
      items: gridItems
    }), outro && react_1.default.createElement(My.Outro, {
      entity: outro
    }), !!blocks.length && react_1.default.createElement(My.Blocks, {
      spacing: 8,
      columns: 3,
      items: blocks.map(function (block, index) {
        return react_1.default.createElement(My.Block, {
          number: index + 1,
          key: block.id,
          entity: block
        });
      })
    }))),
    aside: hasAside && react_1.default.createElement(My.Aside, null)
  }));
};
exports.SliceLayout = SliceLayout;
exports.SliceLayout.defaultProps = exports.SliceLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41;